import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import StateObserver from 'src/StateObserver';
import { createHyperlink } from 'src/lib/ui/utils/text';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupToSUpdated extends PopupBasic {
  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: 547,
      height: 450,
      tracking: { feature: 'tos', $subFeature: 'tos-updated' },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      width: 474,
      height: 400,
      x: 40,
      y: 0,
      size: 38,
    });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        labelOffsetX: -4,
        labelOffsetY: -1,
        fontSize: 38,
        font: bitmapFonts('Body'),
        x: this.box.style.width / 2,
        y: this.box.style.height - 35 - 80 / 2,
        width: 229,
        height: 80,
        centerOnOrigin: true,
        localeText: () => i18n('basic.agree'),
        onClick: async () => {
          sounds.playSound('ok');
          opts.close();
        },
        tracking: {
          feature: 'tos',
          $subFeature: 'tos-updated-accept',
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init() {
    super.init({
      title: i18n('tosUpdated.title'),
      message: i18n('tosUpdated.message'),
    });

    createHyperlink({
      text: this.message,
      regex: /(Terms of Service|サービス利用規約)/g,
      onClick: () =>
        openPopupPromise('popupTermsPolicyDetails', { mode: 'tos' }),
    });

    createHyperlink({
      text: this.message,
      regex: /(Privacy Policy|プライバシーポリシー)/g,
      onClick: () =>
        openPopupPromise('popupTermsPolicyDetails', { mode: 'pp' }),
    });
  }
}
